import { NavLink } from "react-router-dom";
import { Activity, Users, Hash, GitBranch, Flame, Terminal, Beaker, Contact, Ticket, Phone } from "lucide-react";

const items = [
  { to: "/admin", label: "Overview", icon: Activity, end: true, testid: "nav-overview" },
  { to: "/admin/mappings", label: "Mappings", icon: GitBranch, testid: "nav-mappings" },
  { to: "/admin/pool", label: "Shadow Pool", icon: Hash, testid: "nav-pool" },
  { to: "/admin/users", label: "Users", icon: Users, testid: "nav-users" },
  { to: "/admin/burn", label: "Burn List", icon: Flame, testid: "nav-burn" },
  { to: "/admin/vcards", label: "vCards", icon: Contact, testid: "nav-vcards" },
  { to: "/admin/logs", label: "Live Logs", icon: Terminal, testid: "nav-logs" },
  { to: "/admin/simulator", label: "Simulator", icon: Beaker, testid: "nav-simulator" },
  { to: "/admin/invites", label: "Invite Codes", icon: Ticket, testid: "nav-invites" },
  { to: "/admin/proxy-pool", label: "Proxy Pool", icon: Phone, testid: "nav-proxy-pool" },
];

export default function Sidebar() {
  return (
    <aside className="w-64 shrink-0 border-r border-[#1f1f23] bg-[#0b0b0d] min-h-screen flex flex-col">
      <div className="px-6 py-6 border-b border-[#1f1f23]">
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 bg-emerald-400 rounded-full blink" />
          <span className="font-heading text-xl tracking-tight">PROX</span>
        </div>
        <p className="font-mono text-[10px] text-zinc-500 mt-1 tracking-widest uppercase">
          Admin Console · v0.2
        </p>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-1">
        {items.map(({ to, label, icon: Icon, end, testid }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testid}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors duration-150 ${
                isActive
                  ? "bg-[#18181b] text-white"
                  : "text-zinc-400 hover:text-white hover:bg-[#141417]"
              }`
            }
          >
            <Icon className="w-4 h-4" strokeWidth={1.5} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="px-6 py-4 border-t border-[#1f1f23]">
        <a
          href="/"
          className="font-mono text-[10px] text-zinc-600 hover:text-zinc-400 tracking-widest uppercase transition-colors"
        >
          View public site
        </a>
      </div>
    </aside>
  );
}
